export class itemValue{
    Id:string;
    Value:string;
    Image?:string = ""; 
    Title?:string = ""; 
    Checked:boolean;
    Model:any;
}